import { FC } from 'react';
import { Error } from '@mui/icons-material';
import { InputAdornment, TextField } from '@mui/material';
import cn from 'classnames';

import { IFormTextFieldProps } from './FormTextField.interface';

import './styles.scss';

const FormTextField: FC<IFormTextFieldProps> = ({
  className,
  variant = 'filled',
  input: { name, onChange, value, ...otherInput },
  meta,
  InputProps = {},
  helperText = '',
  ...other
}) => (
  <TextField
    {...other}
    className={cn('form-text-field', className)}
    variant={variant}
    name={name}
    helperText={meta.touched ? (!meta.error ? helperText : meta.error) : helperText}
    error={meta.error && meta.touched}
    inputProps={otherInput}
    onChange={onChange}
    value={value}
    InputProps={
      meta.error && meta.touched
        ? {
            ...InputProps,
            endAdornment: (
              <InputAdornment className="form-text-field__error-icon" position="start">
                <Error color="error" />
              </InputAdornment>
            ),
          }
        : InputProps
    }
  />
);

export default FormTextField;
